import axiosConfig from './axiosConfig';

/**
 * Create a reusable list fetcher for resource endpoints.
 * path: API path (e.g. '/admin/users')
 * transformFilters: optional function to massage filter values before sending to API
 */
export function createListFetcher(path, transformFilters) {
    return async function fetcher(params = {}) {
        const { page, perPage, globalSearch, filters, sortBy, sortOrder, ...extraParams } = params;
        const query = { page, per_page: perPage, ...extraParams };
        if (globalSearch) query.search = globalSearch;
        if (sortBy) query.sort = sortBy;
        if (sortOrder) query.dir = sortOrder;

        const toSend = transformFilters ? transformFilters(filters || {}) : (filters || {});

        Object.entries(toSend).forEach(([k, v]) => {
            if (v === undefined || v === null || v === '') return;
            query[k] = v;
        });

        const response = await axiosConfig.get(path, { params: query });
        return response.data;
    };
}
